export class PatientMedicationModel {
    createdDate: any;
    diagCode: any;
    diagnosis: any;
    isActive: any;
    medicineCode: any;
    medicineName: any;
    patientPrescriptionId: any;
    recounciledData: any;
    sig: any;
    status: any;
    unitCode: any;
    addedBy: any;

    constructor() {
        this.createdDate = "";
        this.diagCode = "";
        this.diagnosis = "";
        this.isActive = "";
        this.medicineCode = "";
        this.medicineName = "";
        this.patientPrescriptionId = "";
        this.recounciledData = "";
        this.sig = "";
        this.status = "";
        this.unitCode = "";
        this.addedBy = "";
    }
}
export class DeleteMedication {
    patientPrescriptionId: any = "";
    patientAccount: any = "";
    practiceCode: any = "";
}
export class getMedication {
  Medicine_Name: any = "";
  Practice_code: any = "";
  Provider_code: any = "";
}
export class MedicationRequestNew {
  UserName: any = "";
  Password: any = "";
  ApplicationName: any = "";
}
export class GetPostApiParam {
    PatientAccount: any = "";
    PracticeCode: any = "";
    Query: any = "";
    PaginationSize: any = "";
    EndTo: any = "";
}
export class Medications {
    patientAccount: any = '';
    language: any = '';
    practiceCode: any = '';
    ipAddress: any = '';
    unitCode: any = '';
    medicineName: any = '';
    medicineCode: any = '';
    diagCode: any = '';
    sig: any = '';
    prescriptionId: any = '';
}
export class MedicationsPhoto {
  patientAccount: any = '';
  practiceCode: any = '';
  image: any = '';
}
export class FamilyHistory {
    familyHistorystructureReconcileId: any = "";
    patientAccount: any = "";
    validUserId: any = "";
    practiceCode: any = "";
    realtionShip: any = "";
    name: any = "";
    age: any = "";
    ageAtOnSet: any = "";
    isDeceased: any = "";
    diagnosisList: diagnosisList[] = []
}
export class diagnosisList {
    icdTenCODE: any = "";
    icdTenDescription: any = "";
    icdNineCode: any = "";
    icdNineDescription: any = "";
    snomedDescription: any = "";
}
